import { useState, useCallback } from 'react'

interface CompanyProps {
    kedo: any
    settings: any
}

const useCompany = () => {
    const [companies, setCompanies] = useState<Record<string, any>>([])
    const endpoint = '/kvk/search'

    const autocomplete = useCallback(({ kedo, settings }: CompanyProps) => {
        if (!settings) {
            return
        }

        const params = new URLSearchParams(settings).toString()

        kedo.api()
            .post(`${endpoint}?${params}`, {
                environment_id: kedo.getCurrentEnvironmentId(),
            })
            .then((response) => {
                if (response.data?.resultaten) {
                    let results = response.data.resultaten
                    results = results.map((result, idx) => {
                        if (response.data.extra) {
                            result = {
                                ...result,
                                ...response.data.extra?._embedded
                                    ?.hoofdvestiging?.adressen[idx],
                            }
                        }
                        return result
                    })

                    setCompanies(results)
                } else {
                    setCompanies([])
                }
            })
            .catch(() => {
                setCompanies([])
            })
    }, [])

    return { companies, autocomplete }
}

export default useCompany
